
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 14.667A6.667 6.667 0 118 1.333a6.667 6.667 0 010 13.334zm0-1.334A5.333 5.333 0 108 2.666a5.333 5.333 0 000 10.667zm0-4.388a.77.77 0 01-.77-.77V5.121a.77.77 0 111.54 0v3.052a.77.77 0 01-.77.77zm-.354 2.622a.926.926 0 11.708-1.711.926.926 0 01-.708 1.71z"}})])
          )
        }
      }
    